import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ChecklistEditPage } from "@/components/audits/checklist-edit";
import { toAuditId } from "@/lib/route-params";

const checklistSearchSchema = z.object({
  itemId: z.string().optional(),
  status: z
    .enum(["all", "MISSING", "UPLOADED", "APPROVED"])
    .optional()
    .default("all"),
  search: z.string().optional(),
});

export const Route = createFileRoute(
  "/$workspaceSlug/audits/$auditId/checklist/",
)({
  component: ChecklistEditRoute,
  validateSearch: checklistSearchSchema,
});

function ChecklistEditRoute() {
  const { auditId } = Route.useParams();
  const { itemId, status, search } = Route.useSearch();

  return (
    <ChecklistEditPage
      auditId={toAuditId(auditId)}
      selectedItemId={itemId}
      statusFilter={status}
      searchQuery={search}
    />
  );
}
